'use client';
import * as React from 'react';
import { Controller } from 'react-hook-form';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue, } from './Select';
import { cn } from '../lib/utils';
const AutoShipDropdown = ({ className, control, defaultValue, disabled = false, name, options, prompt, }) => {
    return (React.createElement("div", { className: cn('w-[175px]', className) },
        prompt && (React.createElement("label", { className: "block mb-1 text-xs", htmlFor: `${name}-trigger` }, prompt)),
        React.createElement(Controller, { control: control, name: name, defaultValue: defaultValue, render: ({ value, onChange }) => {
                const selectedValue = value?.value || defaultValue?.value;
                return (React.createElement(Select, { disabled: disabled, onValueChange: (newValue) => {
                        const selectedOption = options.find((option) => option.value === newValue);
                        onChange(selectedOption);
                    }, value: selectedValue, defaultValue: defaultValue?.value },
                    React.createElement(SelectTrigger, { id: `${name}-trigger`, className: "w-full text-sm" },
                        React.createElement(SelectValue, { placeholder: "Select..." })),
                    React.createElement(SelectContent, { className: "z-[12000]" },
                        React.createElement(SelectGroup, null, options.map((option) => (React.createElement(SelectItem, { key: option.value, value: option.value }, option.label)))))));
            } })));
};
export { AutoShipDropdown };
